export default class DatePicker {
    constructor() {

		//Put our input DOM element into a jQuery Object
		var $jqDate = jQuery('input.js-datepicker');

		$jqDate.mask('00/00/0000');

    }
}
 